'use client';

import React, { useCallback, useState } from 'react';
import { useTranslations } from 'next-intl';
import SiteHeader from '../../../components/SiteHeader';
import { StoreFooter } from '../../../components/StoreChrome';
import GoogleSignInButton from '../../../components/GoogleSignInButton';

export default function ContatoPage() {
  const t = useTranslations('paginaContato');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [mensagem, setMensagem] = useState('');

  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [sucesso, setSucesso] = useState<string | null>(null);

  const handleGoogleProfile = useCallback((profile: { name?: string; email?: string }) => {
    if (profile.name) setNome(profile.name);
    if (profile.email) setEmail(profile.email);
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      const res = await fetch('/api/contato', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          nome,
          email,
          telefone: telefone || undefined,
          mensagem,
          origem: 'chat_site',
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        setErro(data.error || t('erroGenerico'));
        return;
      }
      setSucesso(data.contato?.mensagem || t('sucessoFallback'));
    } catch {
      setErro(t('erroGenerico'));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <>
      <SiteHeader />
      <main style={{ background: 'linear-gradient(135deg, #0d1117 0%, #0a1628 55%, #0d1117 100%)' }}>
        <div className="container-site" style={{ padding: '64px 0 96px' }}>
          <p className="eyebrow mb-4" style={{ color: '#1a9fff' }}>
            {t('eyebrow')}
          </p>
          <h1
            className="display-section text-white mb-6"
            style={{ maxWidth: '760px', fontSize: 'clamp(32px, 4vw, 52px)' }}
          >
            {t('titulo')}
          </h1>
          <p className="text-gray-400 mb-14 max-w-xl" style={{ fontSize: '17px', lineHeight: 1.7 }}>
            {t('descricao')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="md:col-span-2">
              {sucesso ? (
                <div
                  style={{
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.14)',
                    borderRadius: '6px',
                    padding: '40px 32px',
                  }}
                >
                  <p className="eyebrow mb-3" style={{ color: '#1a9fff' }}>
                    {t('sucessoEyebrow')}
                  </p>
                  <h2 className="text-white font-semibold mb-4" style={{ fontSize: '22px' }}>
                    {t('sucessoTitulo')}
                  </h2>
                  <p className="text-gray-400" style={{ fontSize: '15px', lineHeight: 1.7 }}>
                    {sucesso}
                  </p>
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  className="flex flex-col gap-4"
                  style={{
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.14)',
                    borderRadius: '6px',
                    padding: '32px',
                  }}
                >
                  {erro && (
                    <div style={{ border: '1px solid #ef4444', borderRadius: '4px', padding: '12px 16px' }}>
                      <p className="text-sm" style={{ color: '#fca5a5' }}>
                        {erro}
                      </p>
                    </div>
                  )}

                  <div>
                    <p className="text-sm text-gray-400 mb-2">{t('googleHint')}</p>
                    <GoogleSignInButton onProfile={handleGoogleProfile} />
                  </div>

                  <label className="flex flex-col gap-1 text-sm text-gray-300">
                    {t('labelNome')}
                    <input
                      type="text"
                      required
                      minLength={3}
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      className="rounded px-3 py-2 text-white"
                      style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.18)' }}
                    />
                  </label>

                  <label className="flex flex-col gap-1 text-sm text-gray-300">
                    {t('labelEmail')}
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="rounded px-3 py-2 text-white"
                      style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.18)' }}
                    />
                  </label>

                  <label className="flex flex-col gap-1 text-sm text-gray-300">
                    {t('labelTelefone')}
                    <input
                      type="tel"
                      value={telefone}
                      onChange={(e) => setTelefone(e.target.value)}
                      className="rounded px-3 py-2 text-white"
                      style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.18)' }}
                    />
                  </label>

                  <label className="flex flex-col gap-1 text-sm text-gray-300">
                    {t('labelMensagem')}
                    <textarea
                      required
                      minLength={5}
                      value={mensagem}
                      onChange={(e) => setMensagem(e.target.value)}
                      rows={5}
                      placeholder={t('placeholderMensagem')}
                      className="rounded px-3 py-2 text-white"
                      style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.18)' }}
                    />
                  </label>

                  <button
                    type="submit"
                    disabled={enviando}
                    className="mt-2 inline-flex items-center justify-center px-8 py-4 text-sm font-semibold transition-all duration-200"
                    style={{
                      background: '#1a9fff',
                      color: '#fff',
                      borderRadius: '4px',
                      opacity: enviando ? 0.6 : 1,
                    }}
                  >
                    {enviando ? t('botaoEnviando') : t('botaoEnviar')}
                  </button>
                </form>
              )}
            </div>

            <div className="flex flex-col gap-4">
              <p className="text-white font-semibold" style={{ fontSize: '15px' }}>
                {t('preferesFalarDireto')}
              </p>
              <a
                href="mailto:comercial@enqdigital.com.br"
                className="inline-flex items-center gap-2 px-5 py-3 text-sm font-medium text-white transition-all duration-200 hover:bg-white hover:text-black"
                style={{ border: '1px solid rgba(255,255,255,0.35)', borderRadius: '4px' }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                comercial@enqdigital.com.br
              </a>
              <a
                href="tel:+554137981370"
                className="inline-flex items-center gap-2 px-5 py-3 text-sm font-medium text-white transition-all duration-200 hover:bg-white hover:text-black"
                style={{ border: '1px solid rgba(255,255,255,0.35)', borderRadius: '4px' }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z" />
                </svg>
                (41) 3798-1370
              </a>
              <a
                href="https://www.instagram.com/enq.digital/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 text-sm font-medium text-white transition-all duration-200 hover:bg-white hover:text-black"
                style={{ border: '1px solid rgba(255,255,255,0.35)', borderRadius: '4px' }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
                @enq.digital
              </a>
              <p className="text-gray-500 mt-2" style={{ fontSize: '13px' }}>
                {t('atendimento')}
              </p>
            </div>
          </div>
        </div>
      </main>
      <StoreFooter />
    </>
  );
}
